import Svg from "components/Svg";
import "./ElementLoader.scss";

const ElementLoader = ({ className, overlay }: { className?: string; overlay?: boolean }) => {
    return (
        <div
            className={`element-loader ${className || ""} ${
                overlay ? "element-loader--overlay" : ""
            }`}
            data-testid="element-loader"
        >
            <Svg icon="elementLoader" />
        </div>
    );
};

export default ElementLoader;
